import { render, staticRenderFns } from "./SettlementHeader.vue?vue&type=template&id=af5d8af8&scoped=true&"
import script from "./SettlementHeader.vue?vue&type=script&lang=js&"
export * from "./SettlementHeader.vue?vue&type=script&lang=js&"
import style0 from "./SettlementHeader.vue?vue&type=style&index=0&id=af5d8af8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5d8af8",
  null
  
)

export default component.exports